module.exports = __webpack_public_path__ + "4d5f9b456de8e0f0a88ed23efafd5915.svg";